module.exports = __webpack_public_path__ + "img/48.5bd3ec6d.jpg";